import { LayoutComponent } from './layout/layout/layout.component';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { SettingsComponent } from './components/settings/settings.component';
import { CereriComponent } from './components/cereri/cereri.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { AdminSetariComponent } from './platform/nomenclatoare/administrativ/admin-setari/admin-setari.component';
import { TokenComponent } from './components/token/token.component';
import { TokenGuard } from './guards/token.guard';
import { RegistruComponent } from './components/registru/registru.component';
import { PermissionsGuard } from './guards/permissions.guard';
import { SlugPageComponent } from './components/slugPage/slug-page.component';
import { AccesInterzisComponent } from './shared/acces-interzis/acces-interzis.component';
import { ConfirmareDocumenteComponent } from './components/confirmare-documente/confirmare-documente.component';

const routes: Routes = [
    {
        path: '',
        redirectTo: '/cereri',
        pathMatch: 'full',

    },
    {
        path: 'access-denied',
        component: AccesInterzisComponent,
    },
    {
        path: '',
        component: LayoutComponent,
        canActivate: [TokenGuard, PermissionsGuard],
        children: [
            {
                path: 'dashboard',
                component: DashboardComponent,
            },
            {
                path: 'settings',
                component: SettingsComponent,
            },
            {
                path: 'cereri',
                component: CereriComponent,
            },
            {
                path: 'registru',
                component: RegistruComponent,
                data: { archived: false },
            },
            {
                path: 'registru-arhiva',
                component: RegistruComponent,
                data: { archived: true },
            },
            {
                path: 'confirmare-documente',
                component: ConfirmareDocumenteComponent,
            },
            {
                path: 'admin-settings',
                component: AdminSetariComponent,
            },
            { path: ':slug', component: SlugPageComponent },
        ],
    },
    {
        path: 'token/:token',
        component: TokenComponent,
    },
    {
        path: '**',
        redirectTo: '/cereri',
    },
];

@NgModule({
    imports: [
        RouterModule.forRoot(routes, {
            scrollPositionRestoration: 'enabled',
            anchorScrolling: 'enabled',
            useHash: true,
        }),
    ],
    exports: [RouterModule],
})
export class AppRoutingModule { }
